import { AccordionModule } from 'primeng-lts/accordion';
import { DropdownModule } from 'primeng-lts/dropdown';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { documentFileViewerComponent } from './documentFileViewer.component';
import { FilePDFViewerModule } from '../filePDFViewer/filePDFViewer.module';
import { TranslateModule } from '@ngx-translate/core';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';

@NgModule({
  declarations: [documentFileViewerComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FilePDFViewerModule,
    SubHeaderModule,
    DropdownModule,
    ScrollPanelModule
    /*
    FormsModule,
    RouterModule,


    PanelModule,*/

  ]
})
export class DocumentFileViewerModule { }
